import { Input, IconStatusWarningExclaimationOutlineRound } from 'cdk-radial';
import styled from 'styled-components';
import { Dropdown } from 'components/Dropdown';

export const StyledPrinterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 16px;
`;

export const StyledOverflowPrinterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledPrinterLabel = styled.span`
  font-family: Roboto, sans-serif;
  letter-spacing: 0.15px;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;

export const StyledEdit = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledPrinterName = styled.span`
  margin-left: 13px;
  letter-spacing: 0.15px;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

export const StyledPrintOrderDiv = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;
`;

export const StyledPrinter = styled.div`
  display: flex;
  margin-right: 5px;
`;

export const StyledOverflowPrinter = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;
  margin-top: 17px;
`;

export const StyledNextAvailableCheckNo = styled.div`
  display: flex;
  align-items: center;
  margin-top: 28px;
  margin-bottom: 7px;
`;

export const StyledCheckSequence = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledColumn = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledPrinterDropdown = styled(Dropdown)`
  width: 195px;
  height: 48px;
`;

export const StyledCheckTrayDropdown = styled(Dropdown)`
  width: 130px;
  height: 48px;
`;
export const StyledOverFlowTrayDropdown = styled(Dropdown)`
  width: 130px;
  height: 48px;
`;
export const StyledInput = styled(Input)`
  width: 256px;
  margin: 0 0.9375rem;
`;
export const StyledRowInfo = styled.div`
  display: flex;
`;

export const StyledIconStatusWarningExclaimationOutlineRound = styled(
  IconStatusWarningExclaimationOutlineRound
)`
  fill: #fa9c19;
`;

export const StyledMessage = styled.div`
  padding-bottom: 20px;
  padding-top: 15px;
  gap: 8px;
  font-family: Roboto, sans-serif;
  font-size: 15px;
  display: flex;
  align-items: center;
`;
